import theme from "theme";
import { colors } from "theme/palette";

import Button from "components/Button";
import Dialog from "components/Dialog";
import ProgressBar from "components/ProgressBar";
import Stack from "components/Stack";
import Text from "components/Text";

import { EChecklistSubmissionDialogStep } from "pages/Deal/DueDiligence/constants";

import { IProgressItem } from "entities/Checklist/components/Notifications/hooks";

export interface ISubmitChecklistDialog {
  open: EChecklistSubmissionDialogStep;
  onClose: () => void;
  onSubmit: () => void;
  checklistProgressData: Array<IProgressItem>;
}

const SubmitChecklistDialog = ({
  open,
  onClose,
  checklistProgressData,
  onSubmit,
}: ISubmitChecklistDialog) => (
  <Dialog
    open={open === EChecklistSubmissionDialogStep.SUBMISSION}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
  >
    <Stack padding={2} gap={2}>
      <Stack padding={2} sx={{ background: colors.blue10, borderRadius: 2 }}>
        <Text variant="h2">Submit & finalize this checklist</Text>
      </Stack>
      <Stack gap={2.5}>
        <Stack padding={theme.spacing(0, 2)} gap={2}>
          <ProgressBar
            sx={{ width: "100%" }}
            progressData={checklistProgressData}
          />
          <Text variant="text2" fontWeight={400} color={colors.gray80}>
            Submitting this checklist will save its current state in a snapshot.
            You will still be able to make changes to the checklist before the
            application deadline.
          </Text>
        </Stack>
        <Stack direction="row" gap={1} alignSelf="flex-end">
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit}>Submit</Button>
        </Stack>
      </Stack>
    </Stack>
  </Dialog>
);
export default SubmitChecklistDialog;
